import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function SimpleSlider() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const res = await fetch("/.netlify/functions/google-reviews");
        const json = await res.json();
        setData(json);
      } catch (err) {
        setError("Failed to load reviews");
      } finally {
        setLoading(false);
      }
    };
    fetchReviews();
  }, []);

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 900,
    slidesToShow: 2,
    slidesToScroll: 2,
    autoplay: false,
    margin: 30,
    responsive: [
      { breakpoint: 991, settings: { slidesToShow: 1 } },
      { breakpoint: 420, settings: { slidesToShow: 1 } },
    ],
  };

  if (loading) {
    return <div className="testimonial-wrapper text-center">Loading reviews...</div>;
  }

  if (error || !data?.reviews?.length) {
    return (
      <div className="testimonial-wrapper text-center">
        <p>{error || "No Google reviews available yet."}</p>
      </div>
    );
  }

  const reviews = data.reviews;

  return (
    <div className="testimonial-wrapper">
      {/* Header with title, rating, and write review button */}
      <div className="d-flex justify-content-between align-items-start mb-4">
        <div className="d-flex flex-column">
          <h3 className="mb-2" style={{ color: '#e6e6e6', fontWeight: 'bold' }}>
            My Google Reviews
          </h3>
          <div className="d-flex align-items-center">
            <div className="me-2" style={{ color: '#FFD700' }}>
              {"★".repeat(Math.round(data.rating || 0))}
            </div>
            <span style={{ color: '#e6e6e6', fontSize: '14px' }}>
              <strong>{data.rating ? data.rating.toFixed(1) : '0.0'}</strong> <strong>rating</strong> of {data.total} reviews
            </span>
          </div>
        </div>
        <a 
          href="https://maps.app.goo.gl/ggq5WopSGEbpJcAD9" 
          target="_blank" 
          rel="noreferrer"
          className="btn"
          style={{ 
            backgroundColor: '#FFD700', 
            color: '#000', 
            border: 'none',
            padding: '8px 16px',
            borderRadius: '6px',
            fontWeight: 'bold',
            textDecoration: 'none'
          }}
        >
          Write a review
        </a>
      </div>

      <Slider {...settings}>
        {reviews.map((r, i) => (
          <div key={i}>
            <div className="testimonial-01 media">
              <div className="avatar">
                <img
                  src={r.authorPhoto || "img/testimonial/placeholder.jpg"}
                  alt={r.authorName}
                  loading="lazy"
                />
              </div>
              <div className="media-body">
                <p>
                  “
                  {r.text && r.text.length > 300
                    ? r.text.slice(0, 300) + "…"
                    : r.text}
                  ”
                </p>
                <h6>{r.authorName}</h6>
                <span>
                  {"★".repeat(Math.round(r.rating || 0))}
                  <span className="opacity-70">
                    {" "}
                    ·{" "}
                    {r.publishTime
                      ? new Date(r.publishTime).toLocaleDateString()
                      : ""}
                  </span>
                </span>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}
